import { render, staticRenderFns } from "./TicketTagPer.vue?vue&type=template&id=20ca9f1b"
import script from "./TicketTagPer.vue?vue&type=script&lang=js"
export * from "./TicketTagPer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports